import { Row, StatusTable, CardSubHeader } from "@egovernments/digit-ui-react-components";
import React from "react";


const AddressMapper = ({ data, header, t }) => {
    delete data["active"]
    return (
    <div style={{ marginTop: "19px", background: "#FAFAFA", border: "1px solid #D6D5D4", borderRadius: "4px", padding: "8px", lineHeight: "19px", maxWidth: "960px", minWidth: "280px" }}>
    <CardSubHeader>{header}</CardSubHeader>
      <StatusTable>
        {Object.keys(data).map((key, index) => (
          <Row
            key={index}
            className="border-none"
            label= {t(`CORE_COMMON_${key.toUpperCase()}`)} // Capitalize the first letter of the key
            text={data[key]  || ""}
          />
        ))}
      </StatusTable>
    </div>
   
    );
  };

export default AddressMapper